import { IconSelectorBlock } from '../commonFragments';
import { gql } from '@apollo/client';
import { CallToActionBlock } from './call-to-action-block';
import { ExternalLinkBlock, InternalLinkBlock } from './link';

export const CallToActionExtendedBlock = gql`
    fragment CallToActionExtendedBlock on CallToActionExtendedRecord {
        __typename
        description {
            value
        }
        icon {
            ...IconSelectorBlock
        }
        link {
            ...InternalLinkBlock
            ...ExternalLinkBlock
        }
    }
    ${IconSelectorBlock}
    ${InternalLinkBlock}
    ${ExternalLinkBlock}
`;

export const PrimaryFooterLeftColumnBlock = gql`
    fragment PrimaryFooterLeftColumnBlock on PrimaryFooterLeftColumnRecord {
        __typename
        title
        links {
            ...InternalLinkBlock
            ...ExternalLinkBlock
        }
        callToAction {
            ...CallToActionBlock
        }
    }
    ${InternalLinkBlock}
    ${CallToActionBlock}
    ${ExternalLinkBlock}
`;

const PrimaryFooterMiddleColumnBlock = gql`
    fragment PrimaryFooterMiddleColumnBlock on PrimaryFooterMiddleColumnRecord {
        __typename
        title
        callToActions {
            ...CallToActionExtendedBlock
        }
    }
    ${CallToActionExtendedBlock}
`;

const PrimaryFooterRightColumnBlock = gql`
    fragment PrimaryFooterRightColumnBlock on PrimaryFooterRightColumnRecord {
        __typename
        title
        callToActions {
            ...CallToActionExtendedBlock
        }
    }
`;

export const PrimaryFooterBlock = gql`
    fragment PrimaryFooterBlock on PrimaryFooterRecord {
        __typename
        left {
            ...PrimaryFooterLeftColumnBlock
        }
        middle {
            ...PrimaryFooterMiddleColumnBlock
        }
        right {
            ...PrimaryFooterRightColumnBlock
        }
    }
    ${PrimaryFooterLeftColumnBlock}
    ${PrimaryFooterMiddleColumnBlock}
    ${PrimaryFooterRightColumnBlock}
`;

export const SecondaryFooterColumnBlock = gql`
    fragment SecondaryFooterColumnBlock on SecondaryFooterColumnRecord {
        __typename
        title
        links {
            ...ExternalLinkBlock
            ...InternalLinkBlock
        }
    }
    ${ExternalLinkBlock}
    ${InternalLinkBlock}
`;

export const SecondaryFooterBlock = gql`
    fragment SecondaryFooterBlock on SecondaryFooterRecord {
        __typename
        items {
            ...SecondaryFooterColumnBlock
        }
    }
    ${SecondaryFooterColumnBlock}
`;

export const PaymentFooterProviderBlock = gql`
    fragment PaymentFooterProviderBlock on PaymentFooterProviderRecord {
        __typename
        title
        image {
            url
        }
    }
`;

export const TertiaryFooterBlock = gql`
    fragment TertiaryFooterBlock on TertiaryFooterRecord {
        __typename
        links {
            ...ExternalLinkBlock
            ...InternalLinkBlock
        }
        vat
    }
`;

export const FooterQuery = gql`
    fragment Footer on FooterRecord {
        __typename
        primary {
            ...PrimaryFooterBlock
        }
        secondary {
            ...SecondaryFooterBlock
        }
        payments {
            ...PaymentFooterProviderBlock
        }
        tertiary {
            ...TertiaryFooterBlock
        }
    }
    ${PrimaryFooterBlock}
    ${SecondaryFooterBlock}
    ${PaymentFooterProviderBlock}
    ${TertiaryFooterBlock}
`;
